import Component from "components/_Shared/Component";

const NavbarStyle = Component('nav')`
	border-bottom: .1px solid #FFFFFF;
	background-color: #3750CF;
	overflow: hidden;
	position: sticky;
	z-index: 100;
	height: 3em;
	width: 100%;
	top: 0;
`;

export { NavbarStyle };